import { render, staticRenderFns } from "./BulkReports.vue?vue&type=template&id=653958c4&scoped=true"
import script from "./BulkReports.vue?vue&type=script&lang=ts"
export * from "./BulkReports.vue?vue&type=script&lang=ts"
import style0 from "./BulkReports.scss?vue&type=style&index=0&id=653958c4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653958c4",
  null
  
)

export default component.exports